import { render, staticRenderFns } from "./ReferralCard.vue?vue&type=template&id=54b1f34d&"
import script from "./ReferralCard.vue?vue&type=script&lang=ts&"
export * from "./ReferralCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports